export const AGENT_PROMPT_RUNTIME_SURFACES = [
    {
        roleId: "orchestrator-agent",
        surfaceId: "ceo-turn",
        title: "CEO Chat",
        titleHi: "CEO चैट",
        productSurface: true,
    },
    {
        roleId: "assistant-agent",
        surfaceId: "assistant-turn",
        title: "Voice Assistant",
        titleHi: "वॉइस असिस्टेंट",
        productSurface: true,
    },
    {
        roleId: "coder-agent",
        surfaceId: "coding-workflow",
        title: "Coding Workflow",
        titleHi: "कोडिंग वर्कफ़्लो",
        productSurface: true,
    },
    {
        roleId: "designer-agent",
        surfaceId: "design-planner",
        title: "Design Studio",
        titleHi: "डिज़ाइन स्टूडियो",
        productSurface: true,
    },
    // Declared roles with no shipping prompt-composing runtime: presets bound
    // only to these are honest previews, never active.
    {
        roleId: "researcher-agent",
        surfaceId: "research",
        title: "Research",
        titleHi: "रिसर्च",
        productSurface: false,
    },
    {
        roleId: "code-reviewer",
        surfaceId: "code-review",
        title: "PR Review",
        titleHi: "PR समीक्षा",
        productSurface: false,
    },
];
export function getAgentPromptSurfaceByRoleId(roleId) {
    return AGENT_PROMPT_RUNTIME_SURFACES.find((s) => s.roleId === roleId);
}
/** Surfaces a preset may compose with that have a live product runtime. */
export function agentPromptActiveSurfaces(preset) {
    return preset.compatibleRoles
        .map((roleId) => getAgentPromptSurfaceByRoleId(roleId))
        .filter((s) => s !== undefined && s.productSurface);
}
/** A preset is runtime-active only if at least one declared role maps to a shipping surface. */
export function isAgentPromptRuntimeActive(preset) {
    return agentPromptActiveSurfaces(preset).length > 0;
}
//# sourceMappingURL=surfaces.js.map